import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedOrder } from '../../../../../../selectors/tools';
import { processOrderItemsCancelAndRefundFlow } from '../../../../../../actions/tools/DecisionTree/OrderActions';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import isEmpty from 'lodash/isEmpty';
import { selectSearchPageLoading } from '../../../../../../selectors/searchPage';
import { CustomNoResultsComponentContextProvider } from '../../Common/NoSearchResults/CustomNoResultsComponentContext';
import { DTNoResultsLink } from '../../../../Common/DTNoResultsLink/DTNoResultsLink';
import { OrderItemsSettingsContextProvider } from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/OrderItemsSettingsContext';

const DTSelectOrderForCancellationAndRefundNode = () => {
  const dispatch = useDispatch();
  const selectedOrder = useSelector(getSelectedOrder);
  const isLoading = useSelector(selectSearchPageLoading);

  const handleNextButtonClick = () => {
    dispatch(processOrderItemsCancelAndRefundFlow());
  };

  return (
    <OrderItemsSettingsContextProvider value={{ hideItemCheckbox: true }}>
      <CustomNoResultsComponentContextProvider value={<DTNoResultsLink />}>
        <DTOrderSearchView
          onNextButtonClick={handleNextButtonClick}
          isNextButtonActive={!isEmpty(selectedOrder) && !isLoading}
        />
      </CustomNoResultsComponentContextProvider>
    </OrderItemsSettingsContextProvider>
  );
};

export default DTSelectOrderForCancellationAndRefundNode;
